import { Navigate, Route, Routes } from 'react-router-dom'
import BoxTruckDriversPage from './BoxTruckDriversPage'

export default function BoxTruckDriversRoutes() {
    return (
        <Routes>
            <Route index element={<BoxTruckDriversPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    )
}
